module.exports = __webpack_public_path__ + "img/injective-1.b39593f3.webp";